import React from 'react';
import PvgHeader from './PvgHeader';
import PvgHero from './PvgHero';
import './PvgHome.css';
import Ourservice from './Ourservice';
import About from './About';
import Career from './Career';
import Fooder from './Footer';
export default function PvgHome() {
   
    return (
        <div className="PvgHome">
            <PvgHeader />
            <div id="home"><PvgHero/></div>
            <div id='services'><Ourservice/></div>
            <div id='About'><About/></div>
            <div><Career/></div>
            <div id='contact'><Fooder/></div>
        </div>
    );
}

